/**
 * @name H5
 * @description
 */
import styled from 'styled-components'
import {TextProps} from 'types'

export default function H5({children, style, label, ...props}: TextProps) {
  return (
    <Element className="essential-text" {...props}>
      {!!label && label}
      {children}
    </Element>
  )
}
//*--------------------------------------------------*
const Element = styled.h5`
  font-size: 15px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.375px;
`
